<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="content min-vh-100 flex-column d-flex justify-content-between">
					<section>
						<h2 class="title">
							<img src="/img/ico-mins-personal-accident.svg" />{{ title }}
						</h2>
						<p>
							<b>{{ intro }}</b>
						</p>
						<div class="accordion" role="tablist">
							<b-card v-for="(coverage, coverage_key) in coverages" :key="coverage_key" no-body class="mb-1">
								<div class="card-header">
									<h6>
										<button v-b-toggle="'coverage-'+coverage_key" class="btn btn-link collapsed" type="button">
											{{ coverage.title }}
										</button>
									</h6>
								</div>
								<b-collapse :id="'coverage-'+coverage_key" accordion="my-accordion" role="tabpanel">
									<b-card-body v-for="(chapter, chapter_key) in coverage.chapters" :key="chapter_key">
										<b-card-title>{{ chapter.title }}</b-card-title>
										<b-card-text v-html="chapter.text"></b-card-text>
										<b-card-sub-title>LIMIT</b-card-sub-title>
										<b-card-text v-html="chapter.limit || '-'"></b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</section>
					<ReadAllTermsAndConditions/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReadAllTermsAndConditions from '@/components/ReadAllTermsAndConditions.vue'

export default {
	components: {
		ReadAllTermsAndConditions,
	},
	data(){
		return {
			title: "TRAVEL INCONVENIENCES",
			intro: "The Company, in case of travel inconveniences, provides the following services:",
			coverages: [
				{
					title: "TRIP CANCELLATION",
					chapters: [
						{
							title: "",
							text: "The Company shall compensate the Insured Party for the sums paid and not reimbursable, withheld by the organizer of the Trip or the Airline based on the Trip Participation Conditions, if the Trip must be cancelled due to one of the following circumstances, provided the situation is documentable, involuntary and unforeseeable at the time of the reservation:<ul><li>Illness, Injury or death of the Insured Party or a Family Member of the same;</li><li>appointment of the Insured Party as a jury member or testimony provided to Judicial Authorities;</li><li>material damage to the dwelling of the Insured Party due to a fire, burglary or natural disaster, of a gravity making the Insured Party’s presence necessary</li></ul>",
							limit: "€3.000 (per Claim and annual aggregate)"
						},
					]
				},
				{
					title: "TRAVEL INTERRUPTION",
					chapters: [
						{
							title: "",
							text: "The Company shall reimburse pro-rata the trip not used, starting on the date of return to the Residence or Domicile in the case of:<ul><li>medical return of the Insured Party, organized and carried out by the Operations Center;</li><li>early return due to death or Hospitalization of a Family Member with prognosis exceeding 7 consecutive days, authorized and organized by the Operations Center.</li><li>act of terrorism or natural disaster in the Trip destination.</li></ul>",
							limit: "€3.000 (per Claim and annual aggregate)"
						},
					]
				},
				{
					title: "FLIGHT INCONVENIENCES - DELAYED DEPARTURE AND FLIGHT CANCELLATION",
					chapters: [
						{
							title: "",
							text: "Following a flight delay (with respect to the scheduled departure time) exceeding 4 hours, the Company shall reimburse documented expenses for hotel, meals and drinks in the period between the scheduled time and the actual departure time.",
							limit: "€ 600 (per claim)"
						},
					]
				},
				{
					title: "FLIGHT INCONVENIENCES - LOSS OF CONNECTION",
					chapters: [
						{
							//title: "",
							text: "In the event of Loss of a Connection, the Company shall reimburse expenses for meals, drinks and hotel in the period between the scheduled flight time and the actual departure time.",
							limit: "€ 600 (per claim)"
						},
					]
				},
				{
					title: "FLIGHT INCONCONVENIENCES - FAILURE TO BOARD",
					chapters: [
						{
							title: "",
							text: "In the event of failure to board a scheduled flight for reasons not attributable to the Insured Party, the Company shall reimburse expenses for meals and drinks in the period between the scheduled time and the actual departure time.",
							limit: "€ 600 (per claim)"
						}
					]
				},
				{
					title: "FLIGHT INCONCONVENIENCES - LATE BAGGAGE DELIVERY",
					chapters: [
						{
							title: "",
							text: "Following a delay exceeding 24 hours in the delivery of baggage (with respect to the scheduled arrival time), the Company shall reimburse purchases for basic necessities (clothing and personal hygiene articles).",
							limit: "€ 600 (per claim)"
						}
					]
				},
				{
					title: "FLIGHT INCONVENIENCES - DIVERTED FLIGHTS",
					chapters: [
						{
							title: "",
							text: "If during the Trip, the airplane on which the Insured Party is traveling changes its initially planned destination as a consequence of a change of course, the Company shall reimburse the expenses for meals, drinks and hotel before reaching the planned destination.",
							limit: "€ 3.000 (per claim)"
						}
					]
				},
				{
					title: "EARLY RETURN DUE TO LOSS OF SAMPLES",
					chapters: [
						{
							title: "",
							text: "If the Insured Party interrupts the Trip due to the loss, theft or destruction of samples, demonstration equipment or product prototypes necessary to perform the work, the Company shall reimburse the travel and lodging costs sustained for the early return to the Party’s Residence or Domicile.",
							limit: "€ 3.000 (per claim)"
						}
					]
				},
			]
		}
	}
}
</script>
